import React from 'react'

const WinTogether = () => {
	return (
		<div className='converseValues-content'>
			<h1 className='section-title'>WIN TOGETHER*</h1>

			<div className='ncss-row' style={{ marginTop: '48px', borderBottom: '1px solid white', paddingBottom: '50px' }}>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						RESPECT
					</p>
					<p className='section-p'>
						We value one another above all. Building a culture of mutual respect by listening as often as we speak up. We
						challenge each other, but we have each other’s back. Always.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						INCLUSIVITY
					</p>
					<p className='section-p'>
						We derive our strength from our unique perspectives and experiences. We see beauty in diversity and its power to
						provoke new ways of thinking and take us to new places.
					</p>
				</div>
				<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm'>
					<p className='section-title' style={{ fontSize: '40px' }}>
						UNITY
					</p>
					<p className='section-p'>
						We succeed as one. Collaboration enables us to move at the pace of youth. Leveraging our collective contributions
						to solve problems and achieve our goals.
					</p>
				</div>
			</div>
			<div className='converse-behaviros'>
				<p className='section-title' style={{ marginTop: '50px', marginBottom: '24px', fontSize: '40px' }}>
					Behaviors
				</p>

				<div className='ncss-row' style={{ marginTop: '24px' }}>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I BUILD TRUST ACROSS MY NETWORK
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I COLLABORATE WITH OTHERS TO ACCELERATE OUR BUSINESS
						</p>
					</div>
					<div className='ncss-col-sm-12 ncss-col-md-4 pb4-sm' style={{ verticalAlign: 'top' }}>
						<p className='section-p' style={{ fontSize: '24px' }}>
							I PUT THE TEAM'S SUCCESS AHEAD OF MY OWN
						</p>
					</div>
				</div>
			</div>
		</div>
	)
}

export default WinTogether



// WEBPACK FOOTER //
// ./src/containers/AboutPage/ConverseValues/WinTogether.js